<template>
  <div class="settings-list">
    <!-- <div class="settings-card smooth-shadow">
      <h4>Grid Resolution</h4>
      <div class="selection-grid">
        <span>5</span>
        <span>8</span>
        <span>10</span>
        <span>12</span>
      </div>
      <input
        class="range"
        v-model="gridLevel"
        type="range"
        min="0"
        max="3"
        step="1"
      />
    </div>

    <div class="settings-card smooth-shadow overlays">
      <h4>Opacity</h4>
      <VueSlider v-model="opacity" @drag-end="setTransparency" />
    </div> -->
    <div class="settings-card smooth-shadow overlays">
      <h4>Overlays</h4>
      <ul>
        <li v-for="layer in getStaticLayers" :key="layer.id">
          <p>{{ layer.name }}</p>
          <Icon type="button" @click="toggleStaticLayer(layer.id)">{{
            layer.isActive ? "check_box" : "check_box_outline_blank"
          }}</Icon>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters("LayerManager", ["getStaticLayers"]),
    ...mapGetters("Map", ["getOverlays"]),
  },
  methods: {
    ...mapActions("LayerManager", ["toggleStaticLayer"]),
    ...mapActions("Map", ["toggleOverlay"]),
  },
};
</script>

<style lang="scss" scoped>
.settings-list {
  display: flex;
  flex-direction: column;
  padding-top: 10px;

  .settings-card {
    display: flex;
    flex-direction: column;
    background: var(--color-secondary);
    margin: 5px 10px;
    padding: 15px 15px;
    border-radius: 5px;

    h4 {
      font-weight: bold;
      padding: 10px 0;
    }

    p {
      margin: 0;
    }
    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;

      li {
        display: flex;
        padding: 5px 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid var(--border-color);

        &:last-child {
          border: 0;
        }
      }
    }

    .selection-grid {
      display: flex;
      justify-content: space-between;
      padding: 5px;

      span {
        width: 10px;
        text-align: right;
      }
    }

    .range {
      appearance: none;
      outline: none !important;
      height: 0.3em;
      border-radius: 0.3em;
      margin: 5px 0;
    }

    input[type="range"]::-webkit-slider-runnable-track {
      width: 100%;
      height: 3;
      cursor: pointer;
      background: var(--font-color-unselected);
      border-radius: 1.3px;
    }

    input[type="range"]:focus::-webkit-slider-runnable-track {
      background: var(--font-color-unselected);
    }

    input[type="range"]::-moz-range-track {
      width: 100%;
      height: 3px;
      cursor: pointer;
      background: var(--font-color-unselected);
      border-radius: 5px;
      border: 0.2px solid var(--border-color);
    }

    input[type="range"]::-ms-track {
      width: 100%;
      height: 3;
      cursor: pointer;
      background: transparent;
      border-color: transparent;
      border-width: 0px 0;
      color: transparent;
    }
    input[type="range"]::-ms-fill-lower {
      background: var(--font-color-unselected);
      border: 0px solid var(--border-color);
      border-radius: 2.6px;
    }
    input[type="range"]:focus::-ms-fill-lower {
      background: var(--font-color-unselected);
    }
    input[type="range"]::-ms-fill-upper {
      background: var(--font-color-unselected);
      border: 0px solid var(--border-color);
      border-radius: 2.6px;
    }
    input[type="range"]:focus::-ms-fill-upper {
      background: var(--font-color-unselected);
    }

    @mixin thumb {
      appearance: none;
      outline: none;
      width: 1em;
      height: 1em;
      background: var(--color-primary);
      border: 0.2em solid var(--color-primary-light);
      border-radius: 1.2em;
      cursor: pointer;
    }

    .range::-webkit-slider-thumb {
      @include thumb;
    }
    .range::-moz-range-thumb {
      @include thumb;
    }
    .range::-ms-thumb {
      @include thumb;
    }
  }
}
</style>
